/**
 * Display metadata for the fragrance.v1 taxonomy. Mirrors
 * device-simulator/shelveslab_sim/taxonomies/fragrance_v1.py. Kept in sync
 * by hand for now — when we wire OTA, this will be served by the cloud.
 */

export type Polarity = "positive" | "negative" | "neutral";

export type TagMeta = {
  tag_id: string;
  polarity: Polarity;
  label: string;
  description: string;
};

const TAGS: TagMeta[] = [
  { tag_id: "SWEETNESS_POS",    polarity: "positive", label: "Sweetness ✓",    description: "Pleasant sweetness" },
  { tag_id: "SWEETNESS_NEG",    polarity: "negative", label: "Too sweet",      description: "Cloying, sugary" },
  { tag_id: "FRESHNESS_POS",    polarity: "positive", label: "Fresh",          description: "Fresh, light, clean" },
  { tag_id: "FRESHNESS_NEG",    polarity: "negative", label: "Flat",           description: "Lacking vibrancy" },
  { tag_id: "HEAVINESS_NEG",    polarity: "negative", label: "Too heavy",      description: "Overpowering" },
  { tag_id: "GIFT_INTENT",      polarity: "neutral",  label: "Gift intent",    description: "Considering as a gift" },
  { tag_id: "MASCULINE_FIT",    polarity: "neutral",  label: "Masculine fit",  description: "Perceived masculine" },
  { tag_id: "FEMININE_FIT",     polarity: "neutral",  label: "Feminine fit",   description: "Perceived feminine" },
  { tag_id: "OFFICE_FIT",       polarity: "neutral",  label: "Office wear",    description: "Suitable for daytime" },
  { tag_id: "EVENING_FIT",      polarity: "neutral",  label: "Evening wear",   description: "Suitable for evening" },
  { tag_id: "PRICE_HESITATION", polarity: "negative", label: "Price too high", description: "Price hesitation" },
  { tag_id: "REPURCHASE_INTENT",polarity: "positive", label: "Repurchase",     description: "Familiar / favorite" },
];

const INDEX: Record<string, TagMeta> = Object.fromEntries(TAGS.map(t => [t.tag_id, t]));

export function tagMeta(id: string): TagMeta {
  return INDEX[id] ?? { tag_id: id, polarity: "neutral", label: id, description: "" };
}

export function polarityColor(p: Polarity): string {
  switch (p) {
    case "positive": return "text-emerald-400";
    case "negative": return "text-rose-400";
    case "neutral":  return "text-amber-300";
  }
}

export function polarityBg(p: Polarity): string {
  switch (p) {
    case "positive": return "bg-emerald-500/10 border-emerald-500/30 text-emerald-300";
    case "negative": return "bg-rose-500/10 border-rose-500/30 text-rose-300";
    case "neutral":  return "bg-amber-500/10 border-amber-500/30 text-amber-300";
  }
}
